export const en = {
    changeable: 'Changeable',
    not_changeable: 'Not changeable',
    unknown_changeable: 'No change information',
    not_refundable: 'Not refundable',
    unknown_refundable: 'No refund information',
    refundable: 'Refundable',
};
